import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DigitalAssetDetailsComponent } from './digital-asset-details.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { PermissionsGuard } from 'shared/permissions/permissions.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'digital-asset/:id/:segment',
        component: DigitalAssetDetailsComponent,
        canActivate: [AuthGuard, PermissionsGuard],
        data: { permissions: ['admin', 'dam-view', 'dam-edit', 'repository'] },
        resolve: { permissions: PermissionsResolver }
      },
      {
        path: 'digital-asset/:id',
        redirectTo: 'digital-asset/:id/details',
        pathMatch: 'full',
        data: { permissions: ['admin', 'dam-view', 'dam-edit', 'repository'] },
        resolve: { permissions: PermissionsResolver }
      },
    ])
  ],
  exports: [RouterModule]
})
export class DigitalAssetDetailsRoutingModule { }
